import { properties } from '../properties.js';
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import i18n from '../I18N/I18n.js'; 
import Web3 from 'web3';
import "../css/userCertificate.css";

import 'react-datepicker/dist/react-datepicker.css'
import NavBar from '../navbar.js';
import LogInNavBar from '../LogInNavBar.js';
import QRCode from "react-qr-code";
import standard_abi from '../../abis/Standard16A-abi.json';
import Footer from '../footer.js';
import ComponenteMultimedia from './ComponenteMultimedia.js';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { withTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import CountrySelect from '../CountrySelect.js';

import { imprimirQR, logout, apiSecuredRequest, apiPublicRequest, checkFileType, isUserOrWallet, _sendMultipleFilesToIPFS, cargarIdiomaPreferido} from '../functions.js';



class CertificateViewer extends Component {

    async componentDidMount() {
		await cargarIdiomaPreferido(this.cambiarIdioma);
		// 1. Carga de Web3
		await this.loadBrandFields();

        const { bearerVar, certificadoId } = await this.checkIfWeb3UserOrLoginUser();
		// 2. Carga de datos de la Blockchain
		await this.loadDpp(bearerVar);
		// 3. Carga los nfts del usuario
	}

    cambiarIdioma = (idioma) => {
		const { i18n } = this.props;
		i18n.changeLanguage(idioma); 
		this.forceUpdate(); 
		Cookies.set('idiomaPreferido', idioma, { expires: 365 });// Cambia el idioma usando i18n
	  };

    logout = async () => {
        this.setState({userBearer: null});
        this.setState({email: null});
        logout();
    }


     async checkIfWeb3UserOrLoginUser() { 
            let params = (new URL(document.location)).searchParams;
            const certificadoId = params.get("certificadoId");
            this.setState({ certificadoId })
            const email = Cookies.get("email");
            
            const userRol = Cookies.get("rol");
            this.setState({ userRol: userRol });
            let bearerVar;
            
            const urlInfo = window.location.pathname.split("/")
           
            this.setState({ empresaMapping: urlInfo[1] })

            
           
           
            if (typeof email === "undefined") {
                this.setState({loggedUser: false});
            }else{
                this.setState({loggedUser: true});
                bearerVar = Cookies.get("id");
                this.setState({email: email});
            }
            
            
            
            this.setState({userBearer: bearerVar})
            return {bearerVar, certificadoId};
        }


    async loadBrandFields() {
        let data = JSON.stringify({
            "email": `${properties.appUser}`,
            "password": `${properties.appPass}`
        });


        const bearerToken = await apiPublicRequest('post', `${properties.apiUrl}/certificat/api/usuario/login`, data);

        let urlParams = (new URL(document.location)).searchParams;
        const certificadoId = urlParams.get("certificadoId")
        this.setState({certificadoId});
        let camposData = JSON.stringify({
            "certificadoId": `${certificadoId}`,
            "tipoStandard": `16CAMPOS`
        });
        const certificadoCompleto = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/empresas/certificado/${certificadoId}`, "", bearerToken.data.accessToken);
        this.setState({certificadoCompleto: certificadoCompleto.data});

       

        const campos = await await apiSecuredRequest(
            'post', 
            `${properties.apiUrl}/certificat/api/campo/getCampos`, 
            camposData, 
            bearerToken.data.accessToken
        );


        
        

        this.setState({ campos: campos.data })
    }

  
    

    async changePestania (pestania) {
		this.setState({ pestaniaSeleccionada: pestania });
	}

    async loadDpp(bearerVar) {
        let params = (new URL(document.location)).searchParams;
        const certificadoId = params.get("certificadoId");
        const idProducto = params.get("idProducto")
        this.setState({ idProducto })
        
        let data = JSON.stringify({
            "idProducto": idProducto,
            "certificadoId": certificadoId,
          });
        const selecttedNftDb = await apiSecuredRequest('post', `${properties.apiUrl}/certificat/api/web3jService/getStandard16ByIdProducto`, data, bearerVar);
        const selecttedNft = selecttedNftDb.data.item;
        let tipoArchivo1 = await checkFileType(selecttedNft.tokenUri);
        this.setState({ tipoArchivo1 });

        let tipoArchivo2 = selecttedNft.tokenUri2 !== "" ? await checkFileType(selecttedNft.tokenUri2) : "";
        this.setState({ tipoArchivo2 });

        let tipoArchivo3 = selecttedNft.tokenUri3 !== "" ? await checkFileType(selecttedNft.tokenUri3) : "";
        this.setState({ tipoArchivo3 });
       
          
       

        const nftSeleccionadoVar = {
            nombre: selecttedNft.nombre ?? "",
            apellido1: selecttedNft.apellido1 ?? "",
            apellido2: selecttedNft.apellido2 ?? "",
            email: selecttedNft.email ?? "",
            documento: selecttedNft.documento ?? "",
            userAddress: selecttedNft.userAddress ?? "",
            id: selecttedNft.id ?? "",
            idProducto: selecttedNft.idProducto ?? "",
            modelo: selecttedNft.modelo ?? "",
            descripcion: selecttedNft.descripcion ?? "",
            campoA1: selecttedNft.campoA1 ?? "",
            userAddress: selecttedNft.userAddress ?? "",
            campoFecha: selecttedNft.campoFecha ?? "",
            tokenUri: selecttedNft.tokenUri ?? "",
            tokenUri2: selecttedNft.tokenUri2 ?? "",
            tokenUri3: selecttedNft.tokenUri3 ?? "",
            campo6: selecttedNft.campo6 ?? "",
            campo0: selecttedNft.campo0  ?? "",
            campo1: selecttedNft.campo1 ?? "",
            campo2: selecttedNft.campo2 ?? "",
            campo3: selecttedNft.campo3 ?? "",
            campo4: selecttedNft.campo4 ?? "",
            campo5: selecttedNft.campo5 ?? "",
            campo7: selecttedNft.campo7 ?? "",
            campo8: selecttedNft.campo8 ?? "",
            campo9: selecttedNft.campo9 ?? "",
            campo10: selecttedNft.campo10 ?? "",
            campo11: selecttedNft.campo11 ?? "",
            campo12: selecttedNft.campo12 ?? "",
            campo13: selecttedNft.campo13 ?? "",
            campo14: selecttedNft.campo14 ?? "",
            campo15: selecttedNft.campo15 ?? ""
        };
        this.setState({nftSeleccionado: nftSeleccionadoVar});
        const abi = standard_abi;
        const address = this.state.certificadoCompleto.direccion;

        var web3 = new Web3(new Web3.providers.HttpProvider(properties.web3Provider));
        const contract = new web3.eth.Contract(abi, address);

        const hashValidation = await contract.methods.checkUserInfo(nftSeleccionadoVar.nombre, nftSeleccionadoVar.apellido1, nftSeleccionadoVar.apellido2, nftSeleccionadoVar.email, nftSeleccionadoVar.documento,
            nftSeleccionadoVar.campoA1,
            nftSeleccionadoVar.modelo,
            nftSeleccionadoVar.idProducto).call({ from: account });

        if (hashValidation == false) {
        	Swal.fire({
                icon: 'error',
                title: `${i18n.t('incorrect')}`,
                text: `${i18n.t('infoNotValidated')}`,
                confirmButtonColor: '#196CF6',
                confirmButtonText: 'Try Again'
            });
        } else{
            Swal.fire({
                title: `${i18n.t('infoValidated')}`,
                titleColor: '#FF0000',
                icon: 'success',
                confirmButtonColor: '#2B4570',
                confirmButtonText: 'Close',
            });
        }


    
    }

    handleCountryChange = async (newCountry) => {
        const nuevoCodigoPais = event.target.value;
        this.setState({ selectedCountry: newCountry });
     

        try {
            let response;
            if(nuevoCodigoPais == "" || newCountry != nuevoCodigoPais){
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${newCountry}`, "", this.state.userBearer);
                this.setState({codigoPais: newCountry });
                
            }else {
                response = await apiSecuredRequest('get', `${properties.apiUrl}/certificat/api/usuario/getLanguajesByCodigoPais/${nuevoCodigoPais}`, "", this.state.userBearer);
                 this.setState({codigoPais: newCountry });
            }
            
            if (response.data && response.data.length > 1) {
                this.setState({multiLanguajeCountry: "true"});
                this.setState({idiomasDisponibles: response.data})
                console.log("Más de un idioma recibido:", response.data);
            } else if (response.data.length == 1) {
                this.setState({multiLanguajeCountry: "false"});
                
            } else {
                console.log("No se recibieron idiomas.");
            }
        } catch (error) {
            // Manejar errores aquí
            console.error("Error al obtener los idiomas:", error);
            Swal.fire({
                title: `${i18n.t('errorOccurred')}`,
                confirmButtonText: `${i18n.t('continue')}`,
                confirmButtonColor: '#E94981',
                icon: 'error',
                iconColor: '#66C08B',
                width: '560px',
            });
        }
    };

     _generateQRCertificate = async()  => {
          const usuario = JSON.parse(localStorage.getItem('usuarioCertificado'));
          
          // QR for quick validation generation
          const QRValidationUrl = `${properties.clientApp}/${this.state.empresaMapping}/standard16/QRValidation?nombre=${usuario.nombre}` +
            `&apellido1=${usuario.apellido1}&apellido2=${usuario.apellido2}&email=${usuario.email}` +
            `&idProducto=${this.state.idProducto}&account=${usuario.walletDir}` +
            `&documento=${usuario.documento}&certificadoId=${this.state.certificadoId}`;
          this.setState({ QRcode: QRValidationUrl })
          this.setState({ showQRcode: true });
          localStorage.removeItem('usuarioCertificado');
        }

        _showQrCode = async() => {
            
            
            // QR for quick validation generation
            const DppQR = `${properties.adminApp}/${this.state.empresaMapping}/standard16DPP?idProducto=${this.state.idProducto}&certificadoId=${this.state.certificadoId}`;
            this.setState({ QRcode: DppQR })
            this.setState({ showQRcode: true });
        }


    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
      };

    constructor(props) {
		super(props)
		this.state = {
			idProducto: null,
			nftSeleccionado: null,
            email: null,
			tipoArchivo1: null,
			tipoArchivo2: null,
			tipoArchivo3: null,
			userId: null,
			userBearer: null,
			campos: null,
			certificadoId: null,
            certificadoCompleto: null,
			empresaMapping: null,
            userRol: null,
            pestaniaSeleccionada: 1,
            loginForm: false,
            primaryKeyForm: false,
            userName: null,
            userPassword: null,
            selectedCountry: null,
            multiLanguajeCountry: "false",
            selectedCountry: null,
            codigoPais: "ESP",
            isChecked: null,
            contract: null,
            QRcode: null,
            showQRcode: false,
            saleDate: null,
            warrantyDate: null,
            loggedUser: null
		};
        this.changePestania = this.changePestania.bind(this)
		
	}


    render(){

        

        if (this.state.nftSeleccionado != null && this.state.campos != null) {

            const fechaA1 = new Date(this.state.nftSeleccionado.campoA1);
            const fecha0 = new Date(this.state.nftSeleccionado.campo0);
            const campoFecha = new Date(this.state.nftSeleccionado.campoFecha);
           
            const fechaFormateada = isNaN(fecha0.getTime()) ? "" : fecha0;
            const empresa = this.state.certificadoCompleto.empresa;
            const camposOpcionales = this.state.campos
            .filter(campo => {
                const match = campo.orden.match(/^CAMPO(\d{1,2})$/);
                return match && parseInt(match[1]) >= 0 && parseInt(match[1]) <= 15;
            });

            return (
                <>
                    {this.state.loggedUser == true ?   <NavBar mail={this.state.email} bearer={this.state.userBearer} logout={this.logout} cambiarIdioma={this.cambiarIdioma} />  : 
                 <LogInNavBar cambiarIdioma={this.cambiarIdioma}/>
                }
        
                   
                    <ComponenteMultimedia
										tipoArchivo1={this.state.tipoArchivo1}
										tipoArchivo2={this.state.tipoArchivo2}
										tipoArchivo3={this.state.tipoArchivo3}
										pestaniaSeleccionada = {this.state.pestaniaSeleccionada}
										changePestania = {this.changePestania}
									/>     


                   
     
                   
                   <div className="content_info_16">
                 
                   {this.state.showQRcode != false && (
                         <div className="modal-overlay">
                  <div className="modal-content form">
                      <button className="modal-close" onClick={() => this.setState({ showQRcode: false })}>
                          {i18n.t('close')}
                      </button>

                      <div className="cewy-qrcode-container">
                          <QRCode value={this.state.QRcode} />

                          <button className="cewy-qrcode-button" onClick={() => imprimirQR(this.state.QRcode)}>
                              {i18n.t('imprimirQR')}
                          </button>
                      </div>
                  </div>
                        
                        </div>
                      
                        
                      )}
                       <div>
                    <h1 className="enterprise_data">{empresa.name}</h1>
                    <h1 className="enterprise_web">{empresa.url}</h1>
                    <h1 className="enterprise_web">{empresa.telefonoContacto}</h1>
                    </div>
                     
                   <p className="product_model_16">{this.state.nftSeleccionado.modelo}</p>
                   <div className="certificateProductData_card_1">
                   <table className="productDetails_table_16">
												
                                                <tr>
                                                    <th className="details_th_16">{i18n.t('Name')}:</th>
                                                    <td className="details_td_16">{this.state.nftSeleccionado.nombre}</td>
                                                </tr>
                                                <tr>
                                                    <th className="details_th_16">{i18n.t('Surname')}:</th>
                                                    <td className="details_td_16">{this.state.nftSeleccionado.apellido1}&nbsp;{this.state.nftSeleccionado.apellido2}</td>
                                                </tr>

                                                <tr>
                                                    <th className="details_th_16">{i18n.t('Email')}:</th>
                                                    <td className="details_td_16">{this.state.nftSeleccionado.email}</td>
                                                </tr>
                                                <tr>
                                                    <th className="details_th_16">{i18n.t('documento')}:</th>
                                                    <td className="details_td_16">{this.state.nftSeleccionado.documento}</td>
                                                </tr>
                                                <tr>
                                                    <th className="details_th_16">{i18n.t('WalletAddress')}:</th>
                                                    <td className="details_td_16"><a className="product_walletAdress_16" href='https://etherscan.io/address/${account}'>{this.state.nftSeleccionado.userAddress}</a></td>
                                                </tr>
                                        </table>
                    


                   </div>
                   <div className="certificateProductData_card_1">
                                           <p className="titleCard_16">{i18n.t('ProductDetails')}</p>
                                           
                                           <table className="productDetails_table_16">
                                                <tbody>
                                                {this.state.campos.some(campo => campo.orden === "IDPRODUCTO") && (
                                                        <tr>
                                                            <th className="details_th_16">
                                                                {i18n.t(this.state.campos.find(campo => campo.orden === "IDPRODUCTO").nombreCampo)}
                                                            </th>
                                                            <td className="details_td_16">{this.state.nftSeleccionado.idProducto}</td>
                                                        </tr>
                                                    )}

                                                    {this.state.campos.some(campo => campo.orden === "CAMPO1A") && (
                                                        <tr>
                                                            <th className="details_th_16">
                                                                {i18n.t(this.state.campos.find(campo => campo.orden === "CAMPO1A").nombreCampo)}
                                                            </th>
                                                            <td className="details_td_16">{fechaA1.toLocaleString()}</td>
                                                        </tr>
                                                    )}

                                                    

                                                    {camposOpcionales.some(campo => campo.orden === "CAMPO0" && campo.mostrar === "true") && (
                                                        <tr key="campo0">
                                                            <th className="details_th_16">{i18n.t(camposOpcionales.find(campo => campo.orden === "CAMPO0").nombreCampo)}</th>
                                                            <td className="details_td_16">{fechaFormateada.toLocaleString()}</td>
                                                        </tr>
                                                    )}


                                                    {this.state.campos.some(campo => campo.orden === "FECHA") && (
                                                        <tr>
                                                            <th className="details_th_16">
                                                                {i18n.t(this.state.campos.find(campo => campo.orden === "FECHA").nombreCampo)}
                                                            </th>
                                                            <td className="details_td_16">{campoFecha.toLocaleString()}</td>
                                                        </tr>
                                                    )}

                                                    {camposOpcionales.map((campo) => {
                                                        const index = campo.orden.slice(5); // Extrae el número del orden
                                                        if (campo.orden === "CAMPO0") return null; // Evita duplicar campo0

                                                        return campo.mostrar === "true" && (
                                                            <tr key={`campo${index}`}>
                                                                <th className="details_th_16">{i18n.t(campo.nombreCampo)}</th>
                                                                <td className="details_td_16">{this.state.nftSeleccionado[`campo${index}`]}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                           
                                       </div>
                   
                                            <button
                                        type="button"
                                        className="cewy_homePage_emailBtn"
                                        onClick={this._showQrCode}
                                        >
                                            {i18n.t('showQR')}
                                        </button>

                                      
                   </div>
                    <Footer /> 

                   
                    
                   
                </>
            );

        }

        

      

    }



}export default withTranslation()(CertificateViewer);